import service from '@/utils/request'

// 发票列表
export function invoiceList ({ invoiceNum, startTime, endTime, startMoney, endMoney, status, pagesize, currentPage, sortField = 'createTime', sort = 'descend', startPayTime, endPayTime }) {
  return service({
    url: '/invoice/searchFinanceDetail',
    method: 'post',
    data: {
      invoiceNum, startTime, endTime, startMoney, endMoney, status, pagesize, currentPage, sortField, sort, startPayTime, endPayTime
    }
  })
}

// 导出发票
export function invoiceExport ({ invoiceNum, startTime, endTime, startMoney, endMoney, status, pagesize, currentPage, sortField = 'createTime', sort = 'descend', startPayTime, endPayTime }) {
  return service({
    url: '/Invoice/ExportFinanceDetail',
    method: 'post',
    data: {
      invoiceNum, startTime, endTime, startMoney, endMoney, status, pagesize, currentPage, sortField, sort, startPayTime, endPayTime
    }
  })
}
// 获取发票信息
export function invoiceInfo () {
  return service({
    url: '/invoice/GetInvoiceTitle',
    method: 'get'
  })
}
// 获取开票内容类别
export function invoiceContentType ({ merchantid }) {
  return service({
    url: '/invoice/GetInvoiceType',
    method: 'get',
    params: { merchantid }
  })
}
// 申请开票
export function appInvoice (data) {
  return service({
    url: '/invoice/createInvoice',
    method: 'post',
    data
  })
}

export function billDetails ({ serialNum, status }) {
  return service({
    url: '/Balance/GetBalanceDetail',
    method: 'get',
    params: {
      serialNum, status
    }
  })
}
// 取消发票
export function cancelInvoice ({ invoiceId }) {
  return service({
    url: '/Invoice/CancelInvoice',
    method: 'get',
    params: { invoiceId }
  })
}
